import { mapState } from 'vuex'

export default {
  data() {
    return {
      filtersList: [
        // {
        //   typeName: 'Geslacht',
        //   typeValue: 'geslacht',
        //   optionsList: [
        //     {
        //       label: 'Mannen',
        //       value: 'm',
        //     },
        //     {
        //       label: 'Vrouwen',
        //       value: 'v',
        //     },
        //     {
        //       label: 'Stellen',
        //       value: 's',
        //     },
        //     {
        //       label: 'Transgender',
        //       value: 't',
        //     },
        //   ],
        // },
      {
        typeName: 'Leeftijd',
        typeValue: 'leeftijd',
        optionsList: [
        {
          label: 'Alle leeftijden',
          value: '',
        },
        {
          label: '18-34',
          value: '18-34',
        },
        {
          label: '35-44',
          value: '35-44',
        },
        {
          label: '45-54',
          value: '45-54',
        },
        {
          label: '55-99',
          value: '55-99',
        },
        ],
      },
      {
        typeName: 'Taal',
        typeValue: 'taal',
        optionsList: [
        {
          label: 'Nederlands',
          value: 'nl',
        },
        {
          label: 'Engels',
          value: 'en',
        },
        {
          label: 'Duits',
          value: 'du',
        },
        {
          label: 'Frans',
          value: 'fr',
        },
        {
          label: 'Spaans',
          value: 'es',
        },
        {
          label: 'Italiaans',
          value: 'it',
        },
        ],
      },
      {
        typeName: 'Haar',
        typeValue: 'haar',
        optionsList: [
        {
          label: 'Blond',
          value: 'blond',
        },
        {
          label: 'Zwart',
          value: 'zwart',
        },
        {
          label: 'Bruin',
          value: 'bruin',
        },
        {
          label: 'Rood',
          value: 'rood',
        },
        {
          label: 'Grijs',
          value: 'grijs',
        },
        ],
      },
      {
        typeName: 'Figuur',
        typeValue: 'figuur',
        optionsList: [
        {
          label: 'Slank',
          value: 'slank',
        },
        {
          label: 'Normaal',
          value: 'normaal',
        },
        {
          label: 'Dik',
          value: 'dik',
        },
        ],
      },
      {
        typeName: 'Uiterlijk',
        typeValue: 'uiterlijk',
        optionsList: [
        {
          label: 'Blank',
          value: 'blank',
        },
        {
          label: 'Zuid-Amerikaans',
          value: 'latina',
        },
        {
          label: 'Aziatisch',
          value: 'aziatisch',
        },
        {
          label: 'Ebony',
          value: 'ebony',
        },
        {
          label: 'Arabisch',
          value: 'arabisch',
        },
        ],
      },
      ],
    };
  },
  computed: {
    ...mapState({
      camsQuery: ({ camStore: { camsQuery } }) => camsQuery,
    }),
  },
  methods: {
    activateFilter(type, name, filterName) {
      let filterState = {
        type: type,
        name: filterName,
      };
      this.$store.commit('camStore/updateFilterState', filterState);
      let filteredQuery = JSON.parse(JSON.stringify(this.camsQuery));
      filteredQuery.page = 1;
      filteredQuery[type] = name;
      this.$store.commit('camStore/updateQuery', filteredQuery);
      this.$store.dispatch('camStore/getCams', filteredQuery);
    },
    deactivateFilter(type) {
      let subQuery = {
        type: type,
        id: '',
      };
      this.$store.commit('camStore/updateQuery', subQuery);
      let pageQuery = {
        type: 'page',
        id: 1,
      };
      this.$store.commit('camStore/updateQuery', pageQuery);
      let filterState = {
        type: type,
        name: false,
      };
      this.$store.commit('camStore/updateFilterState', filterState);
      this.$store.dispatch('camStore/getCams', this.camsQuery);
    },
    toggleFilter(payload) {
      if (payload.isActive) {
        this.deactivateFilter(payload.filterType)
        return
      }
      this.activateFilter(payload.filterType, payload.filterValue, payload.filterName)
    }
  },
}